import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FaConfig, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { SidebarLayout } from '@spotter/components/layout/sidebar/sidebar.component';
import { MainLayoutComponent } from "@spottercomponents/layout/main-layout/main-layout.component";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, MainLayoutComponent],
    templateUrl: './app.html',
    styleUrl: './app.scss'
})
export class App {
    protected readonly title = signal('SeagrassRestorer');

    sidebarLayout: SidebarLayout = {
        sections: [
            {
                title: "Explore", accessRights: 'public', translate: false,
                items: [
                    { id: 'map', routerLink: '/map', title: "Map", icon: 'map', translate: false },
                    { id: 'organisations', routerLink: '/organisations', title: "Organisations", icon: 'building', translate: false },
                    { id: 'projects', routerLink: '/projects', title: "Projects", icon: 'clipboard-list', translate: false },
                    { id: 'sites', routerLink: '/sites', title: "Sites", icon: 'location-pin', translate: false },
                    { id: 'about', routerLink: '/about', title: "About", icon: 'question-circle', translate: false },
                ]
            }
        ]
    }

    constructor(library: FaIconLibrary, faConfig: FaConfig) {
        library.addIconPacks(fas, fab);        // register packs
        faConfig.fixedWidth = true;
        faConfig.defaultPrefix = 'fas';        // optional: lets <fa-icon icon="map"> work
    }

}
